import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import ScheduleSectionForm from '../../../../../ReusableFormSections/ScheduleSection/ScheduleSectionForm'

import { clearCreateCampaignCriterions, createCampaignCriterions } from '../../../../../../modules/actions/campaigns'
import {
  campaignAdScheduleCriterionsSelector,
  createCampaignCriterionsErrorSelector,
  createCampaignCriterionsIsLoadingSelector,
  createCampaignCriterionsWasCreatedSelector
} from '../../../../../../modules/selectors/campaigns'
import { selectedGoogleAdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

import { criterionTypes } from '../../../../../../constants/campaigns'
import { HISTORY_META_EDIT_SECTION, TYPE_CAMPAIGN } from '../../../../../../constants/changeHistory'
import { SCHEDULE } from '../../../../../ReusableFormSections/ScheduleSection/fields'
import { formatScheduleDatesToBE, formatScheduleDatesToFE } from '../../../../../../features/formatters'

const ScheduleSection = ({ editItemData: campaign, title, ...formProps }) => {
  const dispatch = useDispatch()

  const schedule = useSelector(campaignAdScheduleCriterionsSelector)
  const { id: selectedAdAccountId } = useSelector(selectedGoogleAdAccountSelector)
  const criterionsWasCreated = useSelector(createCampaignCriterionsWasCreatedSelector)

  const { id: campaignId } = campaign

  const formattedSchedule = formatScheduleDatesToFE(schedule)

  const handleSubmit = useCallback(
    values => {
      const formattedCriterionsData = {
        account: selectedAdAccountId,
        campaign: campaignId,
        ad_schedule: formatScheduleDatesToBE(values[SCHEDULE]),
        meta: {
          [HISTORY_META_EDIT_SECTION]: title,
          override: {
            item_id: campaignId,
            item_type: TYPE_CAMPAIGN,
            action: 'update'
          }
        }
      }

      dispatch(createCampaignCriterions(formattedCriterionsData, criterionTypes.schedule))
    },
    [dispatch, selectedAdAccountId, campaignId, title]
  )

  const handleClearCreateCriterions = useCallback(() => {
    dispatch(clearCreateCampaignCriterions())
  }, [dispatch])

  return (
    <ScheduleSectionForm
      schedule={formattedSchedule}
      handleSubmit={handleSubmit}
      clearEditItem={handleClearCreateCriterions}
      successSubmit={criterionsWasCreated}
      errorSelector={createCampaignCriterionsErrorSelector}
      isLoadingSelector={createCampaignCriterionsIsLoadingSelector}
      {...formProps}
    />
  )
}

export default ScheduleSection
